import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6ecd099e"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=6ecd099e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports